import { type DataSetConfig } from '@store/dataSetConfigs/types';

import { commercialManagementInvoicesVisibilityColumns } from '../constants/visibilityColumns';

const COMMERCIAL_MANAGEMENT_INVOICES_CONFIG_KEY =
  'commercialManagementInvoices';

const initialCommercialManagementInvoicesConfig: DataSetConfig = {
  sorting: [],
  columnsVisibility: commercialManagementInvoicesVisibilityColumns,
};

export {
  COMMERCIAL_MANAGEMENT_INVOICES_CONFIG_KEY,
  initialCommercialManagementInvoicesConfig,
};
